"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledSearchBox = void 0;
var _SearchBox = require("./SearchBox");
// TODO: in v9, move styled() from SearchBox.jsx to here
var StyledSearchBox = _SearchBox.SearchBox;
exports.StyledSearchBox = StyledSearchBox;